var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0676 0.24356C6.84065 0.921128 3.88003 2.95818 2.08324 5.73734C-0.6241 9.9247 -0.6241 15.3046 2.08324 19.492C5.85546 25.3265 13.7107 27.0005 19.5628 23.2169C25.3973 19.4447 27.0713 11.5895 23.2877 5.73734C21.4699 2.92566 18.5098 0.904931 15.2294 0.236518C13.6856 -0.078147 11.586 -0.0753302 10.0676 0.24356ZM18.5122 8.47062C18.5182 7.97145 18.4703 7.7812 18.3092 7.66336C18.0177 7.45022 17.7362 7.47463 16.8521 7.79C14.213 8.73141 5.48787 12.5016 5.11816 12.8603C4.82943 13.1406 4.82908 13.1435 5.05947 13.3636C5.31041 13.6033 6.82011 14.1324 7.73899 14.3025C8.08734 14.3671 8.46562 14.3649 8.71257 14.2967C8.93463 14.2354 10.3947 13.335 11.9572 12.2957C13.5197 11.2565 14.8906 10.382 15.0035 10.3524C15.1426 10.316 15.2089 10.3664 15.2089 10.5086C15.2089 10.7225 14.6939 11.254 12.2454 13.5677C10.7257 15.0036 10.6211 15.2191 11.189 15.7454C11.7213 16.2384 15.4178 18.6682 15.8047 18.7791C16.3196 18.9267 16.7145 18.736 16.9219 18.2397C17.2242 17.5161 18.4976 9.69407 18.5122 8.47062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTelegram);
export default __webpack_public_path__ + "static/media/SocialIconTelegram.abb9d322fb2e0d8e3cd40c0994e365e2.svg";
export { ForwardRef as ReactComponent };